import { taskMap } from '@/data/tasks';
import { settingsState } from '@/shared/state/settings.svelte';
import { logErrors } from '@/utils/log-errors';
import type { Chore } from '@/types/tasks';

import { activeHolidays } from './activeHolidays.svelte';

class ActiveViewTasks {
    value = $derived.by(() => logErrors(this._value));

    private _value() {
        // const customTaskMap = $state.snapshot(settingsState.customTaskMap) as Record<string, Task>;
        const customTaskMap = settingsState.customTaskMap;

        const activeTasks: string[] = [];

        for (const fullTaskName of settingsState.activeView.homeTasks) {
            const [taskKey, choreKey] = fullTaskName.split('|', 2);
            const task = taskMap[taskKey] || customTaskMap[fullTaskName];
            if (!task || (choreKey && !task.chores.some((chore) => chore?.key === choreKey))) {
                continue;
            }

            // Any task with required holidays needs at least one active
            if (
                task.requiredHolidays?.length > 0 &&
                !task.requiredHolidays.some(
                    (holidayId) => activeHolidays.value[holidayId]?.soon === false
                )
            ) {
                continue;
            }

            const disabledChores = settingsState.activeView.disabledChores?.[fullTaskName] || [];
            const activeChores: Chore[] = [];
            for (const chore of task.chores.filter((chore) => !!chore)) {
                if (
                    !chore ||
                    disabledChores.includes(chore.key) ||
                    (choreKey && chore.key !== choreKey)
                ) {
                    continue;
                }

                if (chore.requiredHolidays?.length > 0) {
                    if (
                        chore.requiredHolidays.some(
                            (holidayId) => activeHolidays.value[holidayId]?.soon === false
                        )
                    ) {
                        activeChores.push(chore);
                    }
                } else {
                    activeChores.push(chore);
                }
            }

            if (
                activeChores.length === 0 ||
                (activeChores.length === 1 && activeChores[0].noAlone)
            ) {
                continue;
            }

            activeTasks.push(fullTaskName);
        }

        return activeTasks;
    }
}

export const activeViewTasks = new ActiveViewTasks();
